// extracted by mini-css-extract-plugin
module.exports = {"desktopImg":"JumpOffCards_desktopImg__ihier","mobileImg":"JumpOffCards_mobileImg__qegPT","el":"JumpOffCards_el__PdyWE"};